import { render, staticRenderFns } from "./project-type-1.html?vue&type=template&id=0a90ce65&scoped=true&external"
import script from "./project-type-1.js?vue&type=script&lang=js&external"
export * from "./project-type-1.js?vue&type=script&lang=js&external"
import style0 from "./project-type-1.scss?vue&type=style&index=0&id=0a90ce65&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a90ce65",
  null
  
)

export default component.exports